import { odinLoadingActions } from '../constants/index';

export const updateOdinLoadingShowingValue = (fetchingValue, animationSpeed = 'normal', animationType = 'overlay') => {
  return {
    type: odinLoadingActions.UPDATE_ODIN_LOADING_VALUE,
    payload: { fetchingValue, animationType, animationSpeed }
  }
}
